// The words and marks of a move that a hand carries: the AI, or the other
// person in a room. Both play the same beats, so a move of a person reads as
// a move of the AI does.

import { KIND_NAMES } from '../engine/abilities';
import { isCapture } from '../engine/moves';
import { squareName } from '../engine/squares';
import type { Move } from '../engine/types';
import { positionOf } from '../game/flow';
import type { GameState } from '../game/state';
import { describePiece, OWNER_NAMES } from '../spells/helpers';
import { type Beat, beat } from './director';

/** The line the move itself wrote. Events after it get their own beats. */
export const moveLine = (before: GameState, after: GameState): string =>
  after.log[before.log.length]?.text ?? '';

export const describeIntent = (state: GameState, move: Move): Beat => {
  const mover = state.board[move.from];
  const target = state.board[move.to];
  const kind = mover ? KIND_NAMES[mover.kind] : 'piece';
  // The wide cue shows two lines of headline. "is moving the knight" takes three.
  const caption = `${OWNER_NAMES[state.turn]} moves the ${kind}`;
  const path = `From ${squareName(move.from)} to ${squareName(move.to)}.`;
  const detail =
    target && isCapture(positionOf(state), move)
      ? `${path} It takes ${describePiece(target, move.to)}.`
      : path;
  return beat(caption, detail, {
    marks: [
      { square: move.from, kind: 'lift' },
      { square: move.to, kind: 'land' },
    ],
  });
};
